module.exports={
    "importGeographies": "Import geographies",
    "ignoredGeographies": "Ignored geographies",
    "share": "Share",
    "deleteDeal": "Delete deal",
    "deleteUserLayer": "Delete user layer?",
    "shareWithOthers": "Share with others",
    "newMapPosition": "New map position",
    "editMapPosition": "Edit map position",
    "feedback": "Feedback",
    "editCutpoints": "Edit cutpoints",
    "waitingForUserToLogIn": "Waiting for user to log in...",
    "loggingOut": "Logging out...",
    "addLocationAnalysisValue": "Add custom value",
    "enterValue": "Enter value",
    "customValueBoundaries": "*Please enter value between {minValue} and {maxValue}",
    "autoAdjustFailed": "Auto-adjust failed",
    "autoAdjustFailedDescription": "Unfortunately, auto-adjust can’t be done for this view. The technical constraint for which autocorrection can be calculated is {limit} geographies.",
    "autoAdjustFailedOptions": "To be able to use auto-adjust, you can:",
    "autoAdjustFailedOption1": "use a lower zoom level  (zoom in), or",
    "autoAdjustFailedOption2": "use higher geography level ",
    "submitFacility": {
        "category": {
            "label": "Category*",
            "placeholder": "Select category"
        },
        "name": {
            "label": "Name*",
            "placeholder": "Facility name"
        },
        "location": {
            "label": "Location*",
            "placeholder": "Enter address"
        },
        "coordinates": {
            "label": "Coordinates",
            "fromPin": "from your map pin",
            "fromAddress": "from the address above",
            "none": "Pick a suggested address, or set a pin on the map",
            "changeWithPin": "Change with pin",
            "setWithPin": "Set with pin"
        },
        "telephone": {
            "label": "Telephone",
            "placeholder": "Telephone number "
        },
        "website": {
            "label": "Website",
            "placeholder": "Web address"
        },
        "status": {
            "label": "Status",
            "placeholder": "Mark as closed , non-existed or duplicate "
        },
        "details": {
            "label": "Details",
            "placeholder": "Provide evidence of what is missing so our team can better review your request",
            "editPlaceholder": "Add additional info"
        },
        "reportMissing": "Report missing data",
        "suggestEdits": "Suggest edits",
        "thankYou": "Thank you for improving TractIQ!",
        "youWillGetEmail": "Your suggestion has been sent, check your email for a copy."
    },
    "saveMap": "Save map",
    "copyMap": "Copy map",
    "resetMap": "Reset map to defaults?",
    "resetSavedMap": "Reset map to last saved?"
}
